module.exports = __webpack_public_path__ + "img/news_5.041a4ad1.png";